module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./OldLogisticsView.js"));
	}, "OldLogisticsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OldLogisticsView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/OldLogistics/OldLogisticsView.js
// module id = 1039
// module chunks = 431